import { render } from "./UpdateNetwork.vue?vue&type=template&id=4ef953f7&scoped=true"
import script from "./UpdateNetwork.vue?vue&type=script&lang=js"
export * from "./UpdateNetwork.vue?vue&type=script&lang=js"

import "./UpdateNetwork.vue?vue&type=style&index=0&id=4ef953f7&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef953f7"]])

export default __exports__